import { ContactList } from "./ContactList";
import { ContactShow } from "./ContactShow";
import { ContactCreate } from "./ContactCreate";

export default {
  list: ContactList,
  show: ContactShow,
  create: ContactCreate,
};
